export default __webpack_public_path__ + "build/15a4b5456cf98d26760471173feb6919.svg";